// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__bzdrl","rotating":"Spinner_rotating__hrlF2"};